import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DoodleResourceService {
  private readonly apiRouteConfig = '/webapp/';

  constructor(
    private http: HttpClient
  ) { }

  public getDoodle(): Observable<any> {
    return this.http.get(this.apiRouteConfig + 'api/core/doodle');
  }
}
